import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

export default function History() {
  return (
    <div className="xl:max-w-6xl my-24 mt-12 mx-auto">
      <div className="w-full flex flex-row flex-wrap px-8 lg:flex-row-reverse">
        <div className="w-full lg:w-1/3 pl-2 flex">
          <StaticImage
            alt="Roentgen"
            src="../../images/roentgen.jpg"
            className="m-auto rounded-lg shadow-2xl w-full h-auto z-0 object-cover object-center"
          />
        </div>
        <div className="w-full lg:w-2/3 text-gray-900 pr-4 text-justify">
          <h2 className="font-semibold text-3xl mt-4">Acerca De</h2>
          <p className="mt-4">
            El 8 de noviembre de 1895 fueron descubiertos los Rayos X por
            Wilhelm Conrad Roetgen, este descubrimiento revolucionó el
            diagnóstico y terapéutica para las Ciencias de la salud. La
            importancia de esta disciplina para la Odontología y la integración
            de saberes en pos de mejores diagnósticos y tratamientos, fueron el
            pensamiento unísono de un grupo de odontólogos generales y
            especialistas y es así como nace la Sociedad Venezolana de
            Radiología e Imagenología Dentomaxilofacial (SVRID) el día 8 de
            noviembre de 2012, previa aprobación por parte del Colegio de
            Odontólogos de Venezuela.
          </p>
          <p className="mt-4">
            A partir de esa fecha, han transcurrido los años y hemos ido
            acumulado experiencias. Las técnicas de imagen se han convertido en
            la piedra angular para el diagnóstico de lesiones, variantes
            anatómicas, enfermedades sistémicas, entre otras, y están marcando
            pauta en la forma de entender y estudiar el complejo maxilofacial,
            sin soslayar a la radiología convencional y cómo sus aportes nos han
            alimentado durante todos estos años y lo seguirán haciendo. Desde
            nuestro ámbito de actuación hemos articulando actividades
            formativas, como cursos, talleres, congresos Nacionales e
            Internacionales y siempre como norte la promoción de nuestra
            especialidad.
          </p>
          <p className="mt-4">
            La SVRID les extiende una cordial invitación a acompañarnos en este
            mundo de la Radiología y la Imagenología Dentomaxilofacial. Nuestra
            responsabilidad siempre será proveer de información precisa a
            nuestros agremiados y a todos los interesados. Es por ello que
            considerando en la actualidad la pandemia COVID-19 y sus
            implicaciones en la atención odontológica en el campo que nos
            compete, hemos realizado el documento Consideraciones y
            recomendaciones de Bioseguridad de SVRID al 8 de abril de 2020,
            pandemia COVID-19
          </p>
          <div className="mt-8">
            <Link
              to="/historia"
              className="bg-blue-700 shadow-xl rounded-lg px-5 py-3 w-auto font-semibold text-gray-50 uppercase"
            >
              Saber Más
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
